import type { PartnerStaff } from '../../models/partnerStaff.ts';
import { useQuery } from '@tanstack/react-query';
import { fetchPartnerStaffs } from '../../api/partner-staff.ts';

export const usePartnerStaffs = (partnerId: string) => {
  return useQuery<PartnerStaff[]>({
    queryKey: ['partnerStaffs', partnerId],
    queryFn: () => fetchPartnerStaffs(partnerId),
  });
};
